export class MatchPlayer {
    constructor(
        readonly email: string,
        readonly name: string,
    ) {}
}
